import React, { useEffect, useState } from "react";
import Select from "react-select";
import LanguageDriverServices from "services/LanguageDriverServices";

const IndicatorSeparator = () => null;

const SelectLanguages = ({
  selectedLanguages,
  setSelectedLanguages,
  name,
  error,
  langId,
  setValue,
}) => {
  const [languageOptions, setLanguageOptions] = useState([]);

  useEffect(() => {
    async function fetchLanguageDriver() {
      try {
        const response = await LanguageDriverServices.getAllLanguageDriver();

        if (response && response.status && Array.isArray(response.data)) {
          const transformedData = response.data.map((item) => ({
            value: item.id,
            label:
              item.lang_driver.charAt(0).toUpperCase() +
              item.lang_driver.slice(1),
          }));

          setLanguageOptions(transformedData);

          // Pre-select from langId after options are loaded
          if (langId && langId.length > 0) {
            const preSelected = transformedData.filter((opt) =>
              langId.includes(opt.value.toString())
            );
            const selectedValues = preSelected.map((opt) => opt.value);

            setSelectedLanguages(selectedValues);
            if (typeof setValue === "function") {
              setValue(name, selectedValues);
            }
          }
        } else {
          console.error("Unexpected API response format:", response);
        }
      } catch (error) {
        console.error("Error fetching languages:", error);
      }
    }

    fetchLanguageDriver();
  }, [langId]);

  const handleLanguageChange = (selectedOptions) => {
    const selectedValues = selectedOptions
      ? selectedOptions.map((option) => option.value)
      : [];
    setSelectedLanguages(selectedValues);
    if (typeof setValue === "function") {
      setValue(name, selectedValues);    
    }
  };

  const getSelectedOptions = () => {
    return selectedLanguages
      ? selectedLanguages
          .map((value) =>
            languageOptions.find((lang) => lang.value === value)
          )
          .filter(Boolean)
      : [];
  };

  return (
    <div>
      <Select
        isMulti
        name={name}
        options={languageOptions}
        value={getSelectedOptions()}
        onChange={handleLanguageChange}
        placeholder="Select languages"
        className="dark:text-gray-300 leading-5 rounded-md focus:border-gray-200 border-gray-200 dark:border-gray-600 focus:ring focus:ring-green-300 dark:focus:border-gray-500 dark:focus:ring-gray-300 dark:bg-gray-700 border h-10 text-sm focus:outline-none block w-full bg-white-100 border-transparent focus:bg-white"
        classNamePrefix="react-select"
        components={{
          IndicatorSeparator,
        }}
      />
      {error && <p className="text-red-500 text-sm mt-1">{error}</p>}
    </div>
  );
};

export default SelectLanguages;
